import { Page } from '@foxtrotplatform/developer-platform-common-ui-component-lib';
import React from 'react';

import { BuiltInApis } from './BuiltInApis';
import { GettingStarted } from './GettingStarted';
import { UserInvitationList } from './UserInvitationList';

export const HomePage: React.FunctionComponent = (): JSX.Element => {
  return (
    <Page>
      <div className="w-os1-page border os1-spacing rounded-md">
        <div className="flex justify-end">
          <UserInvitationList />
        </div>
        <GettingStarted />
        <BuiltInApis />
      </div>
    </Page>
  );
};
